import Vue from 'vue'

class TaxDataService {

	constructor(app){
		this.app = app
	}

	test(string = "$taxDataService is working"){
		console.log(string)
	}

	// Valid tax filing statuses: "Single", "Married Filing Separately", "Head of Household", "Married Filing Jointly", "Qualified Widow(er)"
	// Example state ids: "AL", "AK", "AZ", ...
	async getTaxData(householdIncome, taxFilingStatus, stateId){

		if(!householdIncome && householdIncome != 0){
			console.error("TAX DATA SERVICE: Household income needed")
			return
		}

		if(!taxFilingStatus){
			console.error("TAX DATA SERVICE: Tax filing status needed")
			return
		}

		if(!stateId){
			console.error("TAX DATA SERVICE: State id needed")
			return
		}

		if (taxFilingStatus == "Qualified Widow(er)"){
			taxFilingStatus = "Married Filing Jointly"
		}

		if (["Single", "Married Filing Separately", "Head of Household", "Married Filing Jointly", "Qualified Widow(er)"].indexOf(taxFilingStatus) == -1) {
			console.error("TAX DATA SERVICE: Invalid tax filing status")
			return
		}

		return new Promise( async resolve => {
			if(!this.app.store.state.taxInfo){
				const taxData = await this.getTaxJson()
				this.app.store.commit('updateTaxInfo', taxData)
			}

			const taxInfo = this.app.store.state.taxInfo
			//console.log('taxInfo: ', taxInfo);
			const allDeductionData = taxInfo["data"]["states_with_taxes"][stateId]["deductions"][taxFilingStatus]
			const allTaxData = taxInfo["data"]["states_with_taxes"][stateId]["taxes"][taxFilingStatus]

			let percentageForDeduction = allDeductionData["percentage_for_deduction"]
			const taxCreditAvailable = allDeductionData["maximum_credit"] != null && allDeductionData["maximum_credit"] > 0

			let maximumDeductible = allDeductionData["maximum_deductible_contribution"]
			let maximumDeduction

			let deductionMaximumIncome = allDeductionData["deduction_maximum_income"]
			if(parseInt(deductionMaximumIncome) > 0 && householdIncome > deductionMaximumIncome){
				maximumDeductible = 0
				percentageForDeduction = 0
			}

			if(taxCreditAvailable){
				maximumDeduction = allDeductionData["maximum_credit"]
			}else{
				maximumDeduction = maximumDeductible * percentageForDeduction
			}

			let stateTaxRate = 0

			for(let taxData of allTaxData){
				let minimum = taxData["minimum_tax_bracket"] || -1
				let maximum = taxData["maximum_tax_bracket"] || 999999999999
				if(minimum <= householdIncome && householdIncome <= maximum){
					stateTaxRate = taxData["tax_rate"]
					break
				}
			}

			let perBeneficiaryState = taxInfo["data"]["states_with_taxes"][stateId]["deductions"][taxFilingStatus]["maximum_deductible_beneficiaries"] == 99999

			const federalTaxData = taxInfo["data"]["federal_tax_rates"][taxFilingStatus]
			let federalTaxRate
			let  federalCapitalGains
			for(let taxData of federalTaxData){
				let minimum = taxData["minimum_tax_bracket"] || -1
				let maximum = taxData["maximum_tax_bracket"] || 999999999999
				if(minimum <= householdIncome && householdIncome <= maximum){
					federalTaxRate = taxData["tax_rate"]
					federalCapitalGains = taxData["marginal_capital_gain_rate"]
					break
				}
			}

			const taxDataToReturn = {
				federalInfo: {
					taxRate: federalTaxRate,
					capitalGainsFederal: federalCapitalGains
				},
				stateInfo: {
					taxRate: stateTaxRate || 0,
					maximumDeductible: maximumDeductible,
					maximumDeduction: maximumDeduction,
					percentageForDeduction: percentageForDeduction,
					taxCreditsAvailable: taxCreditAvailable,
					deductionMaximumIncome: deductionMaximumIncome,
					perBeneficiaryState: perBeneficiaryState
				}
			}
			resolve(
				taxDataToReturn
			)
		})
	}

	async getTaxJson(){
		const taxDataUrl = this.app.store.state.config.taxDataJsonUrl
		const taxResponse = await this.app.$httpService.get(taxDataUrl, {})
		return taxResponse
	}

	async deductionInfo(stateStringId){
			return new Promise( async resolve => {
				if(!this.app.store.state.taxInfo){
					const taxData = await this.getTaxJson()
					this.app.store.commit('updateTaxInfo', taxData)
				}

				const taxInfo = this.app.store.state.taxInfo
				let infoToReturn = {state_id: stateStringId}
				try{
					let singleData = taxInfo.data.states_with_taxes[stateStringId].deductions["Single"]
					let marriedData = taxInfo.data.states_with_taxes[stateStringId].deductions["Married Filing Jointly"]

					infoToReturn.single = {}
					infoToReturn.married = {}
					infoToReturn.single.deduction_amount = singleData.maximum_deductible_contribution
					infoToReturn.married.deduction_amount = marriedData.maximum_deductible_contribution

					infoToReturn.has_deduction = false
					if(infoToReturn.single.deduction_amount > 0){
						infoToReturn.has_deduction = true
					}

					infoToReturn.has_credit = false
					if(singleData.maximum_credit){
						infoToReturn.has_deduction = false
						infoToReturn.has_credit = true
						infoToReturn.credit_rate_for_deduction = singleData.percentage_for_deduction
						infoToReturn.single.credit_amount = singleData.maximum_credit
						infoToReturn.married.credit_amount = marriedData.maximum_credit

					}

					infoToReturn.has_deduction_per_account = false
					if(singleData.maximum_deductible_beneficiaries > 1){
						infoToReturn.has_deduction_per_account = true
					}

					infoToReturn.has_parity = false
					if(singleData.maximum_deductible_out_of_state != null){
						infoToReturn.has_parity = true
					}

					infoToReturn.has_unlimited_contributions = false
					if(singleData.maximum_deductible_contribution >= 999999999){
						infoToReturn.has_unlimited_contributions = true
					}
				}catch(e) {
					infoToReturn = {single:{}, married:{}}
				}
				resolve(
					infoToReturn
				)
			})

	}

	async loadOrReturnTaxJson(){
		if (!this.app.store.state.taxInfo) {
			const taxData = await this.getTaxJson()
			this.app.store.commit('updateTaxInfo', taxData)
		}else{
			return this.app.store.state.taxInfo
		}
	}
}

export default ({app}) => {
	const taxDataService = new TaxDataService(app)
	app.$taxDataService = taxDataService
	Vue.prototype.$taxDataService = taxDataService
}
